// Primitivas de UI das calculadoras (design system "Grafite + Petróleo").
// Extraídas dos protótipos em docs/prototipos/*.jsx.

export * from './format'
export * from './use-animated-number'
export * from './icon'
export * from './button'
export * from './cartao-preview'
export * from './detail-row'
export * from './export-modal'
export * from './eyebrow'
export * from './breadcrumb'
export * from './page-shell'
export * from './aviso-box'
export * from './mobile-result-bar'
export * from './money-field'
export * from './stepper'
export * from './lista-itens'
export * from './premium-showcase'
export * from './result-card'
export * from './soft-export'
export * from './faq-item'
export * from './faq-section'
export * from './guide'
export * from './use-calc-telemetry'
export * from './lead-capture'
export * from './salvar-calculo-cta'
export * from './recent-calcs-strip'
